module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c11-093481a3e98e442a8bd7f6a008e776d7.jpg";